module.exports = __webpack_public_path__ + "static/img/face3.c960dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/face3.png
// module id = gp0H
// module chunks = 1